import type { CoreState } from '@/core/store/types'
import type { Brand } from '@/core/types'

export const getBrandLinks =
  (state: CoreState) =>
  (id: string): Brand['links'] | undefined => {
    return state.brands.find((brand) => brand.id === id)?.links
  }
